import { usePersistedDateRange } from "@/hooks/userSettings/usePersistedDateRange";

/**
 * The fault overview's date range, remembered for the signed-in user.
 *
 * Previously kept in this browser's storage, which meant the range was lost on another device
 * and shared between two Geotab users of the same browser profile.
 */
export const useFromToDate = () =>
  usePersistedDateRange({ scope: "faultMonitor.dateRange", defaultLookbackDays: 1 });
